// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider} from "firebase/app-check";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAViPQWsYuj4-w0Xcwpg1utyljButLOHZo",
  authDomain: "leap-digital-media.firebaseapp.com",
  projectId: "leap-digital-media",
  storageBucket: "leap-digital-media.firebasestorage.app",
  messagingSenderId: "345278365105",
  appId: "1:345278365105:web:6cb4c7bc749cdacd3cd190",
  measurementId: "G-HZ831ZP017"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize Firebase App Check
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LcKF54rAAAAADamj_iNMdsAAYEEOzIIvOPBIP-8'),
  isTokenAutoRefreshEnabled: true // Set to true to enable automatic token refresh
});

export {
  auth,
  createUserWithEmailAndPassword,
  db,
  storage
};